export enum LiveRecordingKeys {
    AudioLengthSeconds = "AudioLengthSeconds",
    AudioChunksReceived = "AudioChunksReceived",
    SuccessfullyEnded = "SuccessfullyEnded",
    FailureReason = "FailureReason",
    ServiceInitializationDuration = "ServiceInitializationDuration",
    MicrophoneInitializationDuration = "MicrophoneInitializationDuration",
    MicrophonePremissionsPreviouslyGranted = "MicrophonePremissionsPreviouslyGranted",
    InitializationTotalDuration = "InitializationTotalDuration",
    MicrophoneSuccessfullyInitialized = "MicrophoneSuccessfullyInitialized"
};